"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCoupons = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const StateCoupon_1 = require("./StateCoupon");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateCoupons extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Coupons", true);
        this._includeInactive = false;
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateCoupon_1.StateCoupon);
        this.page.ctrls.blockSearch.hide();
        this._setupFilters();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                this.page.ctrls.btnNew.hide();
            const coupons = yield this._loadCoupons();
            if (!coupons)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(coupons);
            return _super.start.call(this);
        });
    }
    _loadCoupons() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.lockgui(this.app.api.admin.coupons.list(this._includeInactive));
        });
    }
    _setupFilters() {
        this.page.ctrls.blockFilters.show();
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "Show";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Active only", "active"));
        select.append(new Option("All coupons", "all"));
        select.value = this._includeInactive ? "all" : "active";
        select.onchange = () => {
            this._includeInactive = select.value === "all";
            this._reload();
        };
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        return element instanceof HTMLSelectElement ? element : null;
    }
    _reload() {
        return __awaiter(this, void 0, void 0, function* () {
            const coupons = yield this._loadCoupons();
            if (!coupons)
                return;
            yield this.fill(coupons);
        });
    }
    fill(coupons) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.page.ctrls.list.html = "";
            if (!(coupons === null || coupons === void 0 ? void 0 : coupons.length))
                return;
            for (const coupon of coupons) {
                const item = new com.ListItem();
                item.ctrls.lType.text = coupon.isActive ? "Coupon" : "Coupon (inactive)";
                item.ctrls.lId.text = coupon.id ? `#${coupon.id}` : "";
                const description = [];
                if (coupon.code)
                    description.push(gs.text.clearHtmlToText(`Code: ${coupon.code}`));
                if (Number.isFinite(coupon.percent))
                    description.push(gs.text.clearHtmlToText(`Percent: ${Number(coupon.percent).toFixed(2)}%`));
                const periods = this._formatValidity(coupon.validFrom, coupon.validTo);
                if (periods)
                    description.push(gs.text.clearHtmlToText(periods));
                description.push(gs.text.clearHtmlToText(`Used: ${(_a = coupon.usedCount) !== null && _a !== void 0 ? _a : 0}`));
                item.ctrls.pData.html = description.join("<br>");
                item.onclick = () => gs_1.StateGS.Run(StateCoupon_1.StateCoupon, coupon);
                this.page.ctrls.list.append(item);
            }
        });
    }
    _formatValidity(from, to) {
        const parts = [];
        if (from)
            parts.push(`From: ${this._formatDateTime(from)}`);
        if (to)
            parts.push(`To: ${this._formatDateTime(to)}`);
        return parts.length > 0 ? parts.join(" | ") : "";
    }
    _formatDateTime(value) {
        if (!value)
            return "";
        try {
            return value.toLocaleString();
        }
        catch (e) {
            return value.toString();
        }
    }
}
exports.StateCoupons = StateCoupons;
StateCoupons.StateName = "coupons";
//# sourceMappingURL=StateCoupons.js.map